import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import PlusIcon from '../../../assets/plus-icon.svg'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import PaintBrushIcon from '../../../assets/paint-brush-icon.svg'
import { isEmpty } from 'lodash'
import DesignSettingOverlay from '../designSettingOverlay'

const ATGHeaderModal = ({
  componentData,
  modifyData,
  modalSpecificData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  // const { modalData, isEdit } = modalSpecificData
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [logoS3key, setLogoS3key] = useState('')
  const spellNumbers = [
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
  ]
  const [headings, setHeadings] = useState([{ text: '', link: { type: '', data: {} } }])
  const [ctaButtons, setCtaButtons] = useState([{ text: '', link: { type: '', data: {} } }])

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 161,
        height: 70,
        divwidth: '14.1475rem',
        divheight: '8rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError(`logoS3key`)
          setLogoS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setLogoS3key('')
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]
    let tempdata = componentData.data

    setHeadings(tempdata.headings)
    setCtaButtons(tempdata.cta_buttons)
    setLogoS3key(tempdata.logo_s3key)
    if (tempdata?.style_config) {
      setStyleConfig(tempdata?.style_config)
    }

    imgData[0]['assetId'] = tempdata.logo_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj.session_data.cf_domain_name,
      tempdata.logo_s3key,
    )

    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const addNewHeading = () => {
    setHeadings([...headings, { text: '', link: { type: '', data: {} } }])
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (logoS3key.trim().length === 0) {
      isFormValid = false
      temp.logoS3key = 'Upload Image!'
    }

    if (ctaButtons[0].text.trim().length === 0) {
      isFormValid = false
      temp.ctaButtonText1 = 'CTA Button Text Cannot be Empty!'
    }
    if (ctaButtons[1].text.trim().length === 0) {
      isFormValid = false
      temp.ctaButtonText2 = 'CTA Button Text Cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      logo_s3key: logoS3key,
      headings: headings,
      cta_buttons: ctaButtons,
      style_config: styleConfig,
    }

    modifyData(componentData.id, elementObj)
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }

  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        {!isEmpty(designSettingOptions) && (
          <DesignSettingOverlay
            width={'36%'}
            options={designSettingOptions}
            onCancel={() => setDesignSettingOptions([])}
            handleSave={(data) => handleStyleSave(data)}
          />
        )}
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader
          style={{ borderBottom: 0, paddingBottom: 0 }}
          className="d-flex justify-content-center"
        >
          <p style={{ fontSize: '1.3rem' }} className="mb-0 mx-3">
            <b style={{ fontWeight: '500' }}>Header Editor</b>
          </p>
          {isAdvancedEditAllowed && componentData?.data?.style_config && (
            <div
              className={`h-[30px] w-[30px] d-flex justify-content-center align-items-center rounded-full overflow-hidden "`}
            >
              <img
                src={PaintBrushIcon}
                alt="PaintBrushIcon"
                className="cursor-pointer w-full h-full"
                onClick={() => {
                  setDesignSettingOptions(
                    getStyleConfig(['component_background', 'add_btn1', 'add_btn2', 'heading']),
                  )
                }}
              />
            </div>
          )}
        </CModalHeader>
        <CModalBody
          style={{ padding: '0 2rem 0 2rem', fontSize: '13px' }}
          className=" static-scrollbar-class"
        >
          <div className="my-3 px-3 d-flex justify-content-around">
            <div>
              <h6 className="font-13px">
                Logo <span style={{ color: 'red' }}>*</span>
              </h6>
              <ImageUploader data={imageData} />
              <div className="message-text error-message">
                <p>{errorData.logoS3key}</p>
              </div>
              <p style={{ fontSize: '10px', color: '#707070', textAlign: 'center' }}>
                Required dimension: 161 px X 70 px
              </p>
            </div>
          </div>
          {ctaButtons.map((item, idx) => (
            <div className="my-3 border px-3 py-4 header-editor-box " key={idx}>
              <h6 className="font-13px">
                CTA Button{idx + 1}
                <span style={{ color: 'red' }}>*</span>
              </h6>
              <CustomDescriptionBox
                limit={12}
                rows={1}
                value={item.text}
                onChange={(value) =>
                  setCtaButtons((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], text: value }
                    return [...temp]
                  })
                }
                isMandatory={true}
                errorText={errorData[`ctaButtonText${idx + 1}`]}
                style={{ fontSize: '13px' }}
              />
              <AttachLink
                linkData={item.link}
                id={'text2'}
                categoryData={
                  categoryList
                    ? categoryList?.data.filter(
                        (info, idx) => info.type === 'category' && info.status,
                      )
                    : []
                }
                setLinkData={(value) =>
                  setCtaButtons((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], link: value }
                    return [...temp]
                  })
                }
              />
            </div>
          ))}
          {headings.map((item, idx) => (
            <div className="my-3 border px-3 py-4 header-editor-box " key={idx}>
              <h6 className="font-13px">Text {spellNumbers[idx]}</h6>
              <CustomDescriptionBox
                limit={13}
                rows={1}
                value={item.text}
                onChange={(value) =>
                  setHeadings((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], text: value }
                    return [...temp]
                  })
                }
                style={{ fontSize: '13px' }}
              />
              <AttachLink
                linkData={item.link}
                id={'text2'}
                categoryData={
                  categoryList
                    ? categoryList?.data.filter(
                        (info, idx) => info.type === 'category' && info.status,
                      )
                    : []
                }
                setLinkData={(value) =>
                  setHeadings((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], link: value }
                    return [...temp]
                  })
                }
              />
            </div>
          ))}
          <div
            className="my-3 overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 -mt-2 mb-2"
            style={{
              borderRadius: '10px',
              background: '#eeeeee',
              opacity: headings.length < 9 ? '1' : '0.6',
              cursor: headings.length < 9 ? 'pointer' : 'no-drop',
            }}
            onClick={headings.length < 9 ? () => addNewHeading() : undefined}
          >
            <div
              className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
              style={{
                boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)',
                filter: headings.length > 8 ? 'grayscale(100)' : '',
              }}
            >
              <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
            </div>
            <span className="text-sm font-medium mt-2 ">Add New Menu</span>
          </div>
        </CModalBody>
        <CModalFooter>
          <div className="mt-4 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ATGHeaderModal
